import { Component, ContentChildren, QueryList, AfterContentInit, Output, EventEmitter, Input } from '@angular/core';
import { TabComponent } from '../tab/tab.component';

import { CommonModule } from '@angular/common';

import { NgbActiveModal, NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-tab-group',
  standalone: true,
  imports: [
    CommonModule,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle
  ],
  templateUrl: './tab-group.component.html',
  styleUrl: './tab-group.component.scss'
})
export class TabGroupComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;
  @Output() editButtonClicked = new EventEmitter<boolean>();
  @Output() deleteButtonClicked = new EventEmitter<boolean>();
  @Output() addButtonClicked = new EventEmitter<boolean>();
  @Output() saveButtonClicked = new EventEmitter<boolean>();

  activeTab?: TabComponent;


  @Input() sidebars = false;

  ngAfterContentInit() {
    // Activate the first tab by default
    const activeTab = this.tabs.find((tab) => tab.active);
    this.activeTab = activeTab || this.tabs.first;
    if (this.activeTab) {
      this.activeTab.active = true;
    }
  }

  selectTab(index: number) {
    this.tabs.forEach((tab, i) => (tab.active = i === index));
    this.activeTab = this.tabs.toArray()[index];
  }

  onEditButtonClick() {
    if (this.activeTab) {
      this.activeTab.editButtonClicked.emit(true);
    }
  }

  onDeleteButtonlick() {
    if (this.activeTab) {
      this.activeTab.deleteButtonClicked.emit(true);
    }
  }

  onAddButtonClick() {
    if (this.activeTab) {
      this.activeTab.addButtonClicked.emit(true);
    }
  }

  onSaveButtonClick() {
    if (this.activeTab) {
      this.activeTab.saveButtonClicked.emit(true);
    }
  }
}